import React from 'react';
import PropTypes from 'prop-types';
import css from './BarsChartTooltipContent.module.scss';

const BarsChartTooltipContent = ({
  allDataPoints = [],
  monthLabel = '',
  label = '',
  value = '',
  color = '',
  tooltipWidth = null,
}) => {
  // Multi-data point tooltip (stacked charts)
  if (allDataPoints && allDataPoints.length > 0) {
    return (
      <div 
        className={css.tooltipContainer}
        style={tooltipWidth ? { width: tooltipWidth } : undefined}
      >
        {monthLabel && (
          <div className={css.monthLabel}>
            {monthLabel}
          </div>
        )}
        {allDataPoints.map((dp, index) => (
          <div
            key={index}
            className={`${css.dataPointRow} ${dp.isTotal ? css.dataPointRowTotal : ''}`}
          >
            <div className={css.dataPointLabelContainer}>
              {!dp.isTotal && (
                <span
                  className={css.colorIndicator}
                  style={{ background: dp.color }}
                />
              )}
              <span
                className={`${css.dataPointLabel} ${dp.isTotal ? css.dataPointLabelTotal : ''}`}
              >
                {dp.label}
              </span>
            </div>
            <span
              className={`${css.dataPointValue} ${dp.isTotal ? css.dataPointValueTotal : ''}`}
            >
              {dp.value}
            </span>
          </div>
        ))}
      </div>
    );
  }

  // Single data point tooltip (non-stacked charts)
  return (
    <div className={css.singleDataPointContainer}>
      <span
        className={css.colorIndicator}
        style={{ background: color }}
      />
      <span className={css.singleDataPointLabel}>
        {label}
      </span>
      <span className={css.singleDataPointValue}>
        {value}
      </span>
    </div>
  );
};

BarsChartTooltipContent.propTypes = {
  allDataPoints: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      color: PropTypes.string,
      isTotal: PropTypes.bool,
    })
  ),
  monthLabel: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  tooltipWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default BarsChartTooltipContent;
